import { useEffect, useState } from 'react';

/**
 * useInstallPrompt — captures Chrome/Edge's `beforeinstallprompt` once
 * and exposes it to any component that needs to fire the native install
 * dialog. Also tracks whether the app is already running in standalone
 * mode so callers can hide install UI after install.
 */
export default function useInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [installed, setInstalled] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia?.('(display-mode: standalone)').matches ||
           window.navigator.standalone === true;
  });

  useEffect(() => {
    const onBip = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    const onInstalled = () => {
      setInstalled(true);
      setDeferredPrompt(null);
    };
    window.addEventListener('beforeinstallprompt', onBip);
    window.addEventListener('appinstalled', onInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', onBip);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  return { deferredPrompt, installed };
}
